import React from "react";
import ReviewWizard from "./ReviewWizard";
import { ReviewNavigationProvider } from "./useReviewNavigation";
import { ReviewPrimaryActionProvider } from "./useReviewPrimaryAction";
import { buildAutomationChildTestId, resolveAutomationTestId } from "../InputField/testId";

const ReviewShellBoundary = ({
  reviewNavigation,
  loading = false,
  error = null,
  showReviewWizard = true,
  children,
  testId,
}) => (
  <ReviewNavigationProvider value={reviewNavigation}>
    <ReviewPrimaryActionProvider>
      <div className={showReviewWizard ? "fv_review_shell fv_review_shell--active" : "fv_review_shell"} data-testid={resolveAutomationTestId(testId)}>
        {children}
      </div>
      {showReviewWizard ? <ReviewWizard loading={loading} error={error} testId={buildAutomationChildTestId(testId, "dock")} /> : null}
    </ReviewPrimaryActionProvider>
  </ReviewNavigationProvider>
);

export default ReviewShellBoundary;
